import { getConstant } from '../utils';

export const getUsers = getConstant('GET_USERS');
export const resetPassword = getConstant('RESET_PASSWORD_OLD');
export const savePassword = getConstant('SAVE_PASSWORD');
